import { FunctionalComponent, h } from '@stencil/core';
import { TValidationState } from '../../../utils';

type StateMessageProps = {
  message?: string;
  state: TValidationState;
};

export const StateMessage: FunctionalComponent<StateMessageProps> = ({ message, state }) => {
  return (
    <span class="message">
      {state === 'error' && (
        <dc-ui-icon
          name="dc_status_error"
          color="red02"
          size="tiny"></dc-ui-icon>
      )}
      {message}
    </span>
  );
};
